import { css } from '@emotion/react';
import * as React from 'react';

import { PlusSign } from '~src/icons/plus-sign-icon';
import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';
import { LinkButton, LinkButtonProps } from '~src/ui/link-button';

interface AddButtonUIProps extends LinkButtonProps {
  label: string;
}

export const AddButtonUI: React.FC<AddButtonUIProps> = ({ label, ...props }) => {
  return (
    <LinkButton css={styles.button} {...props} data-test="add-button">
      <PlusSign color={colors.black} />
      <span css={styles.text}>{label}</span>
    </LinkButton>
  );
};

const styles = {
  button: css({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    margin: '8px 0 20px',
    padding: '4px 0',
    fontVariationSettings: '"wght" 500',
    color: colors.black,
    ...fontStyles.px12_16,
  }),
  text: css({
    marginLeft: '4px',
  }),
};
